import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from '../../../services/notification.service';
import { FormularioService } from '../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs005-card-XII',
    templateUrl: './rs005-card-XII.component.html'
})

export class Rs005CardXIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listViviparidade?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPopped?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFungos?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLargatas?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listMortePrematura?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public tipoDefeitosIsEnabled: boolean = false;
    @Output() objMakeCalculations = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Severidade para anomalias', false);
        this.formulario = this.formBuilder.group({
            viviparidade_selecao: [null, []],
            popped_kernel_selecao: [null, []],
            ataque_fungos: [null, []],
            ataque_lagartas_select: [null, []],
            morte_prematura_select: [null, []]
        });
    }

    async ngOnInit(): Promise<void> {
        await this.getLists();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    async getLists(): Promise<void> {
        await Promise.all([this.getListAtaqueFungos(),
                           this.getListAtaqueLagartas(),
                           this.getListMortePrematura(),
                           this.getListPopped(),
                           this.getListViviparidade()]);
    }

    async getListViviparidade(): Promise<void> {
        await this.formularioService.getListDropDownList('rs005', 'viviparidade_selecao').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listViviparidade = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);

            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTurnoAmostragem);
        });
    }

    async getListPopped(): Promise<void> {
        await this.formularioService.getListDropDownList('rs005', 'popped_kernel_selecao').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listPopped = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);

            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTurnoAmostragem);
        });
    }

    async getListAtaqueFungos(): Promise<void> {
        await this.formularioService.getListDropDownList('rs005', 'ataque_fungos').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listFungos = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);

            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTurnoAmostragem);
        });
    }

    async getListAtaqueLagartas(): Promise<void> {
        await this.formularioService.getListDropDownList('rs005', 'ataque_lagartas_select').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listLargatas = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);

            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTurnoAmostragem);
        });
    }

    async getListMortePrematura(): Promise<void> {
        await this.formularioService.getListDropDownList('rs005', 'morte_prematura_select').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listMortePrematura = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);

            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTurnoAmostragem);
        });
    }

}